import React, { useState } from 'react';
import axios from 'axios';
import { useDropzone } from 'react-dropzone';
import styles from './index.module.css';
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import ReactLoading from 'react-loading';
import { API_ROUTES, REACT_APP_API_URL } from "../../config/api-config";

const UploadFiles = () => {
  const [csvFile, setCsvFile] = useState(null);
  const [zipFile, setZipFile] = useState(null);
  const token = localStorage.getItem("accessToken");
  const [loading, setLoading] = useState(false);

  const handleCsvFileChange = (e) => {
    console.log(e.target.files[0].name)
    setCsvFile(e.target.files[0]);
    toast.success('CSV file added successfully');
  };

  const handleZipFileChange = (e) => {
    setZipFile(e.target.files[0]);
  };

  const LoadingComp = ({ type, color }) => (
    <ReactLoading type={'balls'} color={'#ffffff'} height={40} width={300} />
  );

  const handleUploadCsv = async () => {
    try {
      if (!csvFile) {
        toast.warn("Please Upload Csv File");
        return;
      }
      const formData = new FormData();
      formData.append('file', csvFile);
      // Adjust the URL based on your FastAPI backend
      let response = await axios.post(REACT_APP_API_URL + API_ROUTES.upload_students_csv,
        formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      });

      toast.success('CSV file is processed. Please check the results.csv for details.');
      setCsvFile(null);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = 'output.csv';
      // Append the link to the document
      document.body.appendChild(a);
      // Trigger the download
      a.click();
      // Remove the link from the document
      document.body.removeChild(a);

    } catch (error) {
      console.error('Error uploading CSV file:', error.message);
      toast.error('Error uploading CSV file');
    }
  };

  const handleUploadZip = async () => {
    try {
      if (!zipFile) {
        toast.warn("Please Upload Zip File");
        return;
      }
      setLoading(true);
      const formData = new FormData();
      formData.append('file', zipFile);
      toast.warn('Zip File is Uploaded. Please wait for few minutes.')       
      let response = await axios.post(REACT_APP_API_URL + API_ROUTES.upload_students_zip, 
        formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
        responseType: 'blob',
      });
  
      toast.success('ZIP file is processed successfully. Please check output.xlsx for registration details and remarks');
      setZipFile(null);

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = 'output.xlsx';
      
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
  
    } catch (error) {
      console.error('Error uploading ZIP file:', error.error);
      toast.error('Error uploading ZIP file.');
    } finally {
      setLoading(false);
    }
  };
  
  const handleDownload = () => {
    // you can change below csvContent string to format data as a sample via adding comma
    const csvContent = "military_id,first_name,middle_name,last_name,email,mobile_no";
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'sample.csv';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const { getRootProps: getCsvRootProps, getInputProps: getCsvInputProps } = useDropzone({
    onDrop: (acceptedFiles) => {
      setCsvFile(acceptedFiles[0]);
    },
    accept: '.csv',
  });

  const { getRootProps: getZipRootProps, getInputProps: getZipInputProps } = useDropzone({
    onDrop: (acceptedFiles) => {
      setZipFile(acceptedFiles[0]);
    },
    accept: '.zip',
  });

  return (
    <div>
      <div className={styles.container}>
        <h1>Upload Files</h1>
        <div>
          <div>
            <div className={styles.downloadBox}>
              <h2 >Upload CSV</h2>
              <button onClick={handleDownload} className={styles.uploadBtn}>Sample CSV</button>
            </div>
            <div className={styles.selectBox} {...getCsvRootProps()}>
              <input type="file" accept=".csv, text/csv" onChange={handleCsvFileChange} {...getCsvInputProps()} />
              <p> {csvFile ? <span style={{ fontSize: '1.3rem' }}> {`"${csvFile?.name}" selected.  Please wait after uploading file.`}</span> : "Drag 'n' drop a CSV file here, or click to select a CSV file"} </p>
            </div>
            <button className={styles.uploadBtn} onClick={handleUploadCsv} >
              Upload CSV
            </button>
          </div>
          <div>
            <div className={styles.downloadBox}>
              <h2>Upload ZIP</h2>
              <input type="file" accept=".zip" onChange={handleZipFileChange} {...getZipInputProps()} />
            </div>
            <div {...getZipRootProps()} className={styles.selectBox}>
              <p>  
              {loading ? (
                <ReactLoading type={'bars'} color={'#ab55gg'} height={200} width={200} />
              ) : zipFile ? (
                <span style={{ fontSize: '1.3rem' }}>{`"${zipFile?.name}" selected. Please wait after uploading file.`}</span>
              ) : (
                "Drag 'n' drop a ZIP file here, or click to select a ZIP file"
              )}
              </p>
            </div>
            <button className={styles.uploadBtn} onClick={handleUploadZip} disabled={loading}>
              Upload ZIP
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadFiles;
